module.exports = __webpack_public_path__ + "media/Filters/filters-8fee9f8f.svg";